import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router-dom'
import classnames from 'classnames';
import {
  Pie, Tooltip, Legend,
  ResponsiveContainer, PieChart
} from 'recharts';
import {
  Row, Col, CardBody, Badge, Nav, NavItem, NavLink,
  TabContent, TabPane
} from 'reactstrap';
import frameworkMapping from '../../../utils/frameworkMapping'
import { connect } from 'react-redux';
import { signout } from '../../../redux/actions/userActions';
import Table from '../../table/Table'
import { withApollo } from 'react-apollo';
import { GetDueControls, GetDueControlsForUser } from '../../../queries/controls'
import { 
  GetComplianceAssessmentData,
  GetComplianceAssessmentV2,
  GetHIPAAAssessmentData 
} from '../../../queries/assessment'
import { GetEnabledSubModules } from '../../../queries/users'
import moment from 'moment'
import slugify from 'slugify'
import ProgressBar from 'react-bootstrap/ProgressBar'
import '../../../scss/component/statistics.scss';
import { Query } from 'react-apollo'
import TrainingCard from './TrainingCard'
import moduleMapping from '../../../utils/moduleMapping'
import Progress from './ProgressBar';
import $ from 'jquery';

const currentCompliance = [
  { name: 'Compliant', value: 0, fill: '#2d9aa6', controlCount: 0, label: 'Compliant Controls' },
  { name: 'Ready for Review', value: 0, fill: '#0f3d59', controlCount: 0, label: 'Controls Ready for Review' },
  { name: 'Not Compliant', value: 0, fill: '#f24b59', controlCount: 0, label: 'Non-Compliant Controls' },
  { name: 'Not Applicable', value: 0, fill: '#f2a71a', controlCount: 0, label: 'Not Applicable Controls' },
  { name: 'Awaiting Evidence', value: 0, fill: '#50c3d0', controlCount: 0, label: 'Controls Awaiting Evidence' }];

// const areaData = [
//   { name: 'May', iso: 5, gdpr: 15, nist: 40, pci: 21, hipaa: 12 },
//   { name: 'Jun', iso: 15, gdpr: 23, nist: 42, pci: 28, hipaa: 34 },
//   { name: 'Jul', iso: 35, gdpr: 47, nist: 52, pci: 40, hipaa: 40 },
//   { name: 'Aug', iso: 55, gdpr: 68, nist: 52, pci: 50, hipaa: 48 },
//   { name: 'Sept', iso: 65, gdpr: 68, nist: 58, pci: 60, hipaa: 60 },
//   { name: 'Oct', iso: 75, gdpr: 90, nist: 60, pci: 65, hipaa: 70 },
//   { name: 'Nov', iso: 98, gdpr: 91, nist: 67, pci: 87, hipaa: 89 },
// ];

const renderCustomizedLabel = ({ x, y, value }) => {
  return (
    <text x={x} y={y} dy={10} dx={0} fontSize={13} textAnchor="middle">
      {`${value > 1 ? value + '%' : ''}`}
    </text>
  );
};

const CustomTooltip = (props) => {
  if (props.active) {
    return (
      <div className="custom-tooltip">
        <p className="label">{`${props.payload[0].payload.label} : ${props.payload[0].payload.controlCount}`}</p>
      </div>
    );
  }
  else {
    return null;
  }
}

const legendOpts = {
  onClick: (e, item) => alert(`Item with text ${item.text} and index ${item.index} clicked`)
};

class Statistics extends PureComponent {
  constructor(props) {
    super(props);

    this._isMounted = false;

    this.state = {
      legend: legendOpts,
      currentCompliance: currentCompliance,
      dueControls: [],
      dueControlsForUser: [],
      loadedDueControls: false,
      loadedDueControlsForUser: false,
      activeTab: '1',
      trainingStats: [],
      steps: [
        {
          target: '.left-side',
          content: 'This is my awesome feature!',
          placement: 'top',
          disableScrolling : true
        },
        {
          target: '.right-side',
          content: 'This is my awesome feature!',
          placement: 'top'
        }
      ]
    };

    this.applyLegendSettings = this.applyLegendSettings.bind(this);
  }

  componentWillUnmount () {
    this._isMounted = false;
  }

  async componentDidMount () {

    (async () => {
      try {
        this._isMounted = true;
        this.getCompliantData()
        const { data: dueControls } = await this.props.client.query({
          query: GetDueControls(),
          fetchPolicy: 'network-only',
          skip: this.state.loadedDueControls
        })

        /**
         * These queries are no longer necessary.
         * TODO: Delete them completely.
         */
        /*const { data: companyAssessment } = await this.props.client.query({
          query: GetComplianceAssessmentData(),
          fetchPolicy: 'network-only',
          skip: this.state.loadedDueControlsForUser
        })


        const { data: hippaAssessmentData } = await this.props.client.query({
          query: GetHIPAAAssessmentData(),
          fetchPolicy: 'network-only',
          skip: this.state.loadedDueControlsForUser
        })*/


        const { data: dueControlsForUser } = await this.props.client.query({
          query: GetDueControlsForUser(this.props.user.sub),
          fetchPolicy: 'network-only',
          skip: this.state.loadedDueControlsForUser
        })

        if (dueControls && this._isMounted) {
          let _data = Object.assign({}, dueControls)
          this.setState({
            dueControls: _data.dueControls.slice().sort((a, b) => a.dueDate - b.dueDate),
            loadedDueControls: true
          })
        }
        
        /**
         * Stop saving assessment data to local storage. Security Risk
         * TODO: Whenever and wherever this data is necessary, get it at that time and store it in state.
         */
        /*if(companyAssessment && this._isMounted){
          localStorage.setItem('assessment', JSON.stringify(companyAssessment.complianceAssessment))
        }

        if(hippaAssessmentData && this._isMounted){
          localStorage.setItem('hipaa', hippaAssessmentData.getHIPAAComplianceAssessment.assessmentData)
        }*/

        if (dueControlsForUser && this._isMounted) {
          let _data = Object.assign({}, dueControlsForUser)
          this.setState({
            dueControlsForUser: _data.getControlsByAssignedUser.slice().sort((a, b) => a.dueDate - b.dueDate),
            loadedDueControlsForUser: true
          })
        }
      } catch (e) {
        if (e.networkError) {
          if (e.networkError['statusCode'] === 401) {
            this.signoutUser()
          }
        } else {
          console.log(e.message)
          this.signoutUser()
        }
      }
    })().catch(error => {
      console.log(error)
    })

  }

   async componentDidUpdate (prevProps) {
    if (this._isMounted) {
      if (this.props.summary !== prevProps.summary) {
        this.getCompliantData()
      }
      if (this.props.sidebar.show || this.props.sidebar.collapse) {
        document.querySelector('.right-side')
          .style.width = document.querySelector('.left-side').style.width / 2
      }
      if (this.props.summary.frameworkSummary !== prevProps.summary.frameworkSummary) {
        await this.getUpcomingControlData();
      }
    }
  }

  async getUpcomingControlData(){
    (async () => {
    try {
      const { data: dueControlsForUser } = await this.props.client.query({
        query: GetDueControlsForUser(this.props.user.sub),
        fetchPolicy: 'network-only',
        skip: this.state.loadedDueControlsForUser
      })

      const { data: dueControls } = await this.props.client.query({
        query: GetDueControls(),
        fetchPolicy: 'network-only',
        skip: this.state.loadedDueControls
      })

      if (dueControls) {
        let _data = Object.assign({}, dueControls)
        this.setState({
          dueControls: _data.dueControls.slice().sort((a, b) => a.dueDate - b.dueDate),
          loadedDueControls: true
        })
      }

      if (dueControlsForUser && this._isMounted) {
        let _data = Object.assign({}, dueControlsForUser)
        this.setState({
          dueControlsForUser: _data.getControlsByAssignedUser.slice().sort((a, b) => a.dueDate - b.dueDate),
          loadedDueControlsForUser: true
        })
      }
    }
    catch(error){
      console.log(error)
    }
    }
    )().catch(error => {
      console.log(error)
    })
  }

  getCompliantData () {
    let stats = Object.assign({}, this.props.summary)

    if (stats && stats.controlSummary && this._isMounted) {
      stats.total = stats.controlSummary.totalEnabledControls

      this.setState({
        currentCompliance: [
          {
            label: 'Compliant Controls',
            controlCount: stats.controlSummary ? stats.controlSummary.numControlsCompliant : 0,
            name: 'Compliant',
            value: stats ? Number((stats.controlSummary.numControlsCompliant / stats.total * 100).toFixed(2)) : 0,
            fill: '#2d9aa6'
          },
          {
            label: 'Controls Ready for Review',
            controlCount: stats.controlSummary ? stats.controlSummary.numControlsAwaitingReview : 0,
            name: 'Ready for Review',
            value: stats ? Number((stats.controlSummary.numControlsAwaitingReview / stats.total * 100).toFixed(2)) : 0,
            fill: '#0f3d59'
          },
          {
            label: 'Non-Compliant Controls',
            controlCount: stats.controlSummary ? stats.controlSummary.numControlsNotCompliant : 0,
            name: 'Not Compliant',
            value: stats ? Number((stats.controlSummary.numControlsNotCompliant / stats.total * 100).toFixed(2)) : 100,
            fill: '#f24b59'
          },
          {
            label: 'Not Applicable Controls',
            controlCount: stats.controlSummary ? stats.controlSummary.numControlsNotApplicable : 0,
            name: 'Not Applicable',
            value: stats ? Number((stats.controlSummary.numControlsNotApplicable / stats.total * 100).toFixed(2)) : 0,
            fill: '#f2a71a'
          },
          {
            label: 'Controls Awaiting Evidence',
            controlCount: stats.controlSummary ? stats.controlSummary.numControlsAwaitingEvidence : 0,
            name: 'Awaiting Evidence', 
            value: stats ? Number((stats.controlSummary.numControlsAwaitingEvidence / stats.total * 100).toFixed(2)) : 0,
            fill: '#50c3d0'
          }]
      })
    }
  }

  applyLegendSettings () {
    const { value } = this.legendOptsInput;

    try {
      const opts = JSON.parse(value);
      this.setState({
        legend: opts
      });
    } catch (e) {
      alert(e.message);
      throw Error(e);
    }
  };

  signoutUser () {
    this.props.signout();
    this.props.history.push('/');
  }

  goToControl = (framework, controlID, lowLevelCategory, highLevelCategory) => {
    const encodedFrameworkName = (frameworkMapping[framework].name);
    const encodedhighLevelCategory = (highLevelCategory === null ? '' : `/${highLevelCategory}`).toLowerCase().replaceAll(" ","-");
    const encodedLowLevelCateogry = (lowLevelCategory).toLowerCase().replaceAll(" ","-");
    const encodedControlID = (controlID)
    this.props.history.push(`/app/compliance/${encodedFrameworkName}${encodedhighLevelCategory}?category=${encodedLowLevelCateogry}&controlId=${encodedControlID}`);
  }

  toggle (tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }


  render () {
    let stats = Object.assign({}, this.props.summary)
    let isHipaaEnabled;
    let isCmmcOneEnabled;
    let isCmmcTwoEnabled;
    let isCmmcThreeEnabled;
    this.props.enabledFrameworks.forEach(framework=>{
      if(framework.id === 7){
        isHipaaEnabled = true
      }
      if(framework.id === 10){
        isCmmcOneEnabled = true
      }
      if(framework.id === 11){
        isCmmcTwoEnabled = true
      }
      if(framework.id === 12){
        isCmmcThreeEnabled = true
      }
    })

    let statusGraph;
    if(this.props.summary!==null && this.props.controlSummary!==null){
      if(
        this.props.summary.controlSummary.numControlsAwaitingEvidence === 0 &&
        this.props.summary.controlSummary.numControlsAwaitingReview === 0 &&
        this.props.summary.controlSummary.numControlsCompliant === 0 &&
        this.props.summary.controlSummary.numControlsNotApplicable === 0 &&
        this.props.summary.controlSummary.numControlsNotCompliant === 0
        ){
          statusGraph=<ResponsiveContainer height={300}><CardBody className="no-frameworks-selected">
              <p className="no-frameworks-body"> No controls updated </p>
            </CardBody></ResponsiveContainer>
        }
        else{
          statusGraph=<ResponsiveContainer height={300}>
            <PieChart width={500} height={250}>
                    <Tooltip content={CustomTooltip} />
                    <Pie
                      paddingAngle={this.state.currentCompliance[2].value < 100 ? 3 : 0}
                      labelLine={false} data={this.state.currentCompliance}
                      dataKey='value' cx={'50%'} cy={'50%'}
                      innerRadius={60}
                      onMouseEnter={null}
                      onMouseOver={null}
                      outerRadius={80}
                      isAnimationActive={false}
                      label={renderCustomizedLabel} />
                    <Legend layout="horizontal" verticalAlign="bottom" align="center" />
              </PieChart>
          </ResponsiveContainer>
        }
    }

    return (
      <div className="card-container statistics-container">
        <div className="left-side">
          {isHipaaEnabled ? 
        <div className=' card project-summary__statistics'>
        <CardBody className='dashboard-card'>
          <div className="title-container">
          <h5 className='project-summary__statistic-title'>HIPAA Compliance Maturity Score</h5>
      <Query
        query={GetComplianceAssessmentV2()}
        fetchPolicy={'network-only'}
        variables={{ assessmentType: "hipaa" }}
        onError={(e) => {
          if (e.networkError) {
            if (e.networkError['statusCode'] === 401) {
              this.signoutUser()
            }
          } else {
            console.log(e.message)
            this.signoutUser()
          }
        }}
        onCompleted={(data) => {
        }}>
        {({ loading, error, data }) => {
        if (loading) return (<ProgressBar id="hipaa-progress-bar" striped animated variant="customProgressHigh" now={100} 
        label={`Calculating Score`}/>)
        if (error) { this.signoutUser() }
        return (<div>
                  <Progress id="hipaa-progress-bar" data={data.complianceAssessmentV2} assessmentName="hipaa"/>
                  {data.complianceAssessmentV2 == null ? null : <p style={{textAlign:'center'}}><i>On average businesses start with a score of 43</i></p>}
                </div>)
        }}
      </Query>
    </div>
      </CardBody>
        </div>
        : null  
        }
          

        {isCmmcOneEnabled || isCmmcTwoEnabled || isCmmcThreeEnabled ? 
        <div className=' card project-summary__statistics'>
          <CardBody className='dashboard-card'>
            <div className="title-container">
              <h5 className='project-summary__statistic-title'>CMMC Compliance Maturity Score</h5>
          <Query
              query={GetComplianceAssessmentV2()}
              fetchPolicy={'network-only'}
              variables={{ assessmentType: "cmmc" }}
              onError={(e) => {
                if (e.networkError) {
                  if (e.networkError['statusCode'] === 401) {
                    this.signoutUser()
                  }
                } else {
                  console.log(e.message)
                  this.signoutUser()
                }
              }}
              onCompleted={(data) => {
              }}>
              {({ loading, error, data }) => {
              if (loading) return (<ProgressBar id="cmmc-progress-bar" striped animated variant="customProgressHigh" now={100} 
              label={`Calculating Score`}/>)
              if (error) { this.signoutUser() }
              return (<div>
                        <Progress id="cmmc-progress-bar" data ={data.complianceAssessmentV2} assessmentName="cmmc"/>
                        {data.complianceAssessmentV2 == null ? null : <p style={{textAlign:'center'}}><i>Recommended Starting Level: {data.complianceAssessmentV2.level} </i></p>}
                      </div>
                      )
              }}
            </Query>
          </div>
            </CardBody>
              </div> : null}

          <div className=' card project-summary__statistics'>
            <CardBody className='dashboard-card'>
              <div className="title-container">
                <h5 className='project-summary__statistic-title'>Overview</h5>
                {/* <hr /> */}
              </div>
              <Row>
                <Col md={4} className='heading-metric'>
                  <div>
                    {stats && stats.controlSummary ? stats.controlSummary.numFrameworksEnabled : 0}
                  </div>
                  {stats && stats.controlSummary ? stats.controlSummary.numFrameworksEnabled === 1 ?
                    'Framework' : 'Frameworks' : ''}
                </Col>

                <Col md={4} className='heading-metric'>
                  <div>
                    {stats && stats.controlSummary ?
                      stats.controlSummary.totalEnabledControls > 0 ?
                        Math.round(
                          (stats.controlSummary.numControlsCompliant + stats.controlSummary.numControlsNotApplicable) / stats.controlSummary.totalEnabledControls * 100
                        ) + `%` : 'N/A' :
                      '0%'}</div>
                  Completed
                </Col>

                <Col md={4} className='heading-metric'>
                  <div>
                    {stats && stats.controlSummary ? stats.controlSummary.totalEnabledControls : 0}
                  </div>
                  {stats && stats.controlSummary ? stats.controlSummary.totalEnabledControls === 1 ?
                    'Control Enabled' : 'Controls Enabled' : ''}

                </Col>
              </Row>
            </CardBody>
          </div>

          {this.props.settings.modules.includes(moduleMapping.TRAINING) ? 
            <div className=' card project-summary__statistics'>
                <CardBody className='dashboard-card'>
                    <div className="title-container">
                        <h5 className='project-summary__statistic-title'>Training by User</h5>
                        <Query
                              query={GetEnabledSubModules()}
                              fetchPolicy={'network-only'}
                              variables={{ module: "training" }}
                              onError={(e) => {
                                if (e.networkError) {
                                  if (e.networkError['statusCode'] === 401) {
                                    this.signoutUser()
                                  }
                                } else {
                                  console.log(e.message)
                                  this.signoutUser()
                                }
                              }}
                              onCompleted={(data) => {
                              }}>
                              {({ loading, error, data }) => {
                              if (loading) return (<div style={{ textAlign: 'center', margin: '20px' }}>Loading...</div>)
                              if (error) { console.log(`ERROR > ${error.message}`); return null }
                              return (<TrainingCard
                                          subModules={data.getSubModules}
                                />)
                              }}
                            </Query>

                      </div> 
                  </CardBody>
              </div> : null  
            }

        </div>
        <div className="right-side">
          <div className=' card project-summary__statistics' style={{ float: 'left', height: '452px' }}>
            <CardBody className='dashboard-card'>
              <div className='project-summary__statistic'>
                <h5 className='project-summary__statistic-title'>Control Status</h5>
                {/* <hr /> */}

                  {statusGraph}
                  {/*<PieChart width={500} height={250}>
                    <Tooltip content={CustomTooltip} />
                    <Pie
                      paddingAngle={this.state.currentCompliance[2].value < 100 ? 3 : 0}
                      labelLine={false} data={this.state.currentCompliance}
                      dataKey='value' cx={'50%'} cy={'50%'}
                      innerRadius={60}
                      onMouseEnter={null}
                      onMouseOver={null}
                      outerRadius={80}
                      isAnimationActive={false}
                      label={renderCustomizedLabel} />
                    <Legend layout="horizontal" verticalAlign="bottom" align="center" />
                          </PieChart>*/}
              </div>
            </CardBody>
          </div>
          {/* Upcoming Controls */}
          <div className=' card project-summary__statistics' style={{ float: 'left' }}>
          <CardBody className='dashboard-card'>
              <div className='project-summary__statistic_quick title-container'>
                <h5 className='project-summary__statistic-title'>Upcoming Controls</h5>
                <Nav tabs>
                  <NavItem>
                    <NavLink
                      className={`pointer-element ${classnames({ active: this.state.activeTab === '1' })}`}
                      onClick={() => {
                        this.toggle('1');
                      }}
                    >
                      For You
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={`pointer-element ${classnames({ active: this.state.activeTab === '2' })}`}
                      onClick={() => {
                        this.toggle('2');
                      }}
                    >
                      For Your Company
                    </NavLink>
                  </NavItem>
                </Nav>
                
                <TabContent activeTab={this.state.activeTab}>
                  <TabPane tabId='1'>
                  <div style={{overflowY: 'auto', maxHeight: '290px'}}>
                      {this.state.dueControlsForUser && this.state.dueControlsForUser.length > 0 ?

                        <Table className='table--bordered table-hover' responsive striped>
                          <thead>
                            <tr>
                              <th>Ref ID</th>
                              <th>Framework</th>
                              <th>Assigned To</th>
                              <th>Deadline</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.dueControlsForUser.map((control, i) => {
                              const today = moment(Date.now())
                              const dueDate = moment(control.dueDate)
                              const user = this.props.users ? this.props.users.find(u => u.sub === control.assignedTo) :
                                null

                              let framework = Object.values(frameworkMapping).find(f => {
                                return f.id === Number(control.framework)
                              })

                              return <tr
                                key={i}
                                onClick={() =>
                                  this.goToControl(control.framework,
                                    control.controlID,
                                    control.lowLevelCategory,
                                    control.highLevelCategory
                                    )}>
                                <td>{control.referenceID}</td>
                                <td>{framework ? framework.humanName : 'N/A'}</td>
                                <td>{user ? `${user.given_name} ${user.family_name}` : 'Not Assigned'}</td>
                                <td>
                                  <Badge
                                    color={
                                      today.diff(dueDate, 'minutes') > 1 ?
                                        'danger' :
                                        dueDate.diff(today, 'days') >= 1 ?
                                          'success' : 'warning'
                                    }>
                                    {moment(control.dueDate).fromNow()}</Badge></td>
                              </tr>
                            })}
                          </tbody>
                        </Table>

                        : <div style={{ textAlign: 'center', margin: '20px' }}>No Upcoming Controls </div>}
                    </div>
                  </TabPane>
                  <TabPane tabId='2'>
                  <div style={{overflowY: 'auto', maxHeight: '290px'}}>
                      {this.state.dueControls && this.state.dueControls.length > 0 ?

                        <Table className='table--bordered table-hover' responsive striped>
                          <thead>
                            <tr>
                              <th>Ref ID</th>
                              <th>Framework</th>
                              <th>Assigned To</th>
                              <th>Deadline</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.dueControls.map((control, i) => {
                              const today = moment(Date.now())
                              const dueDate = moment(control.dueDate)
                              const user = this.props.users ? this.props.users.find(u => u.sub === control.assignedTo) :
                                null

                              let framework = Object.values(frameworkMapping).find(f => {
                                return f.id === Number(control.framework)
                              })

                              return (<tr
                                key={i}
                                onClick={() =>
                                  this.goToControl(control.framework,
                                    control.controlID,
                                    control.lowLevelCategory,
                                    control.highLevelCategory
                                    )}>
                                <td>{control.referenceID}</td>
                                <td>{framework ? framework.humanName : 'N/A'}</td>
                                <td>{user ? `${user.given_name} ${user.family_name}` : 'Not Assigned'}</td>
                                <td>
                                  <Badge
                                    color={
                                      today.diff(dueDate, 'minutes') > 1 ?
                                        'danger' :
                                        dueDate.diff(today, 'days') >= 1 ?
                                          'success' : 'warning'
                                    }>
                                    {moment(control.dueDate).fromNow()}</Badge></td>
                              </tr>)
                            })}
                          </tbody>
                        </Table>

                        : <div style={{ textAlign: 'center', margin: '20px' }}>No Upcoming Controls </div>}
                    </div>
                  </TabPane>
                </TabContent>
              </div>
            </CardBody>
          </div>

          <div className=' card project-summary__statistics'>
            <CardBody className='dashboard-card'>
                <div className='project-summary__statistic_quick'>
                  <h5 className='project-summary__statistic-title'>Quick Menu</h5>
                  {/* <hr /> */}
                  {this.props.enabledFrameworks && this.props.enabledFrameworks.length > 0 ?
                    this.props.enabledFrameworks.map(f => {
                      return (
                        <Link
                          className="primary-dashboard-link"
                          key={f.name}
                          to={`/app/compliance/${f.path}`}>
                          <h4>{f.humanName} Controls</h4>
                        </Link>)
                    }) : null}
                  
                  {/* <Link className="primary-dashboard-link" to='/app/training'><h4>Training</h4></Link> */}
                  {/* <Link className="primary-dashboard-link" to='/app/user/profile'><h4>Settings</h4></Link>  */}
                  <Link className="primary-dashboard-link" to='/logout'><h4>Logout</h4></Link>
                </div>
              </CardBody>
          </div>
        </div>
        {/* <div>
          <Col md={12} className=' card project-summary__statistics'>
            <CardBody className='dashboard-card'>
              <div className='project-summary__statistic'>
                <h5 className='project-summary__statistic-title'>Compliance Over Time (2018)</h5>
                <ResponsiveContainer height={300}>
                  <AreaChart data={areaData}
                    margin={{ top: 0, right: 0, left: -15, bottom: 0 }}>
                    <XAxis dataKey='name' />
                    <YAxis unit='%' domain={[0., 100]} />
                    <CartesianGrid strokeDasharray='3 3' />
                    <Tooltip />
                    {this.props.frameworks && this.props.frameworks.length > 0 ? this.props.frameworks.map((f, i) => {
                      return (
                        <Area 
                        name={`${f.humanName}`} 
                        type='monotone' 
                        key={f.name} 
                        dataKey={f.name} 
                        stroke={f.color} 
                        fill={f.fill_color} 
                        fillOpacity={0.3} />)
                    }) : null}
                    <Legend layout='vertical' verticalAlign='middle' wrapperStyle={style} />
                  </AreaChart>
                </ResponsiveContainer>
              </div>
            </CardBody>
          </Col>
        </div> */}
      </div >
    )
  }
}

function mapStateToProps (state) {
  return {
    controls: state.controlsData.controls,
    frameworks: state.controlsData.frameworks,
    enabledFrameworks: state.controlsData.enabledFrameworks,
    summary: state.controlsData.summary,
    users: state.controlsData.users,
    user: state.auth.user,
    sidebar: state.sidebar,
    settings: state.auth.settings
  }
}

export default connect(mapStateToProps, { signout })(withRouter(withApollo(Statistics)))


// WEBPACK FOOTER //
// ./src/components/compliance/components/Statistics.js